function Footer() {
  return <div className="footer">
    <p>Challenge by <a href="https://www.frontendmentor.io?ref=challenge" target="_blank">Frontend Mentor</a>. </p>
    <p>Coded by <a href="https://www.frontendmentor.io/profile/giovanigomez1" target="_blank">Giovani</a>.</p>
  </div>
}


export default Footer